module.exports = __webpack_public_path__ + "media/images/soar/faq_process-80c0fb52c1d17d0cf79905df744b125f.png";